import { call, put } from "redux-saga/effects";
import { routes } from "../../common/api/routes";
import {
  getStrengths,
  getStrengthsError,
  getStrengthsSuccess,
} from "../actions";

export function* getStrengthsSaga(params) {
  yield put(getStrengths(params.data));
  try {
    const response = yield call(routes.getStrengths, params.data);
    yield put(getStrengthsSuccess(response));
  } catch (error) {
    yield put(getStrengthsError(error));
  }
}